const currencyEntries = [
  ['USD', '$'],
  ['EUR', '€'],
  ['GBP', '£'],
  ['JPY', '¥'],
  ['AUD', 'A$'],
  ['CAD', 'CA$'],
  ['CHF', 'CHF'],
  ['CNY', '¥'],
  ['INR', '₹'],
  ['RUB', '₽'],
] as const

export type CurrencyCode = (typeof currencyEntries)[number][0]

export type CurrencySymbol = (typeof currencyEntries)[number][1]

export const currencySymbolMap = new Map<CurrencyCode, CurrencySymbol>(currencyEntries)
